import { delay, put } from 'redux-saga/effects';

import { processingAggregatesRequest } from '@store/filing/aggregates/aggregates.reducer';

export const pollProcessingAggregatesSaga = function* ({ payload }) {
  while (true) {
    yield delay(1000 * 5); // Debounce
    yield put(processingAggregatesRequest(payload));
  }
};
